'use client';
import { useEffect, useRef } from 'react';

let sent = false;
export const NotFoundAnalytics = () => {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    if (sent) return;

    if (window.clarity) {
      window.clarity('404 pageview', document.referrer || 'no referrer');
    }

    const pureHref = window.location.origin + window.location.pathname;
    fetch('/api/log/', {
      method: 'POST',
      body: JSON.stringify({
        attributes: {
          status_code: 404,
          location: pureHref,
          referrer: document.referrer,
        },
        message: '404 pageview',
      }),
    });
    sent = true;
  }, []);

  // переходя из разных страницна 404 иногда добавляется класс паддинга а иногда нет, проверяем если нет то добавляем
  useEffect(() => {
    if (!ref.current) return;

    const refParent = ref.current.parentElement;
    if (!refParent) return;

    const parentClassList = refParent.classList;
    if (parentClassList && !parentClassList.contains('lg:pt-[184px]')) {
      parentClassList.add('pt-24');
      parentClassList.add('sm:pt-[136px]');
      parentClassList.add('md:pt-[168px]');
      parentClassList.add('lg:pt-[184px]');
    }
  }, [ref.current]);

  return <span ref={ref} className='hidden' />;
};
